import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Card } from '../../components/ui/card';
import { 
  ChevronDown, 
  ChevronUp, 
  Calendar, 
  Users, 
  Award, 
  FileText, 
  Download,
  CheckCircle2,
  History,
  Building2,
  Target,
  Heart,
  BookOpen
} from 'lucide-react';
import { Button } from '../../components/ui/button';

const AboutPage = () => {
  const [expandedSection, setExpandedSection] = useState('history');

  // Executive Committee Data
  const executiveCommittees = [
    {
      id: 1,
      title: 'प्रथम कार्यकारिणी / First Executive Committee',
      tenure: '31 मई, 1987 से 17 जून, 1990',
      members: [
        { position: 'अध्यक्ष', name: 'श्री अचलदास महादान धनदे', location: 'बिलासपुर', type: 'elected' },
        { position: 'मंत्री', name: 'श्री सुखदेवप्रसाद ईश्वरलालजी कीरी', location: 'जोधपुर', type: 'elected' },
        { position: 'उपाध्यक्ष', name: 'श्री भागचंद मूलचंदजी मामतोरा', location: 'डीसा', type: 'nominated' },
        { position: 'उप मंत्री', name: 'श्री आशाराम हीरालालजी छूंछा', location: 'बीकानेर', type: 'nominated' },
        { position: 'कोषाध्यक्ष', name: 'श्री रामलाल टेलारामजी गिराछ', location: 'जोधपुर', type: 'nominated' },
      ],
      activities: [
        'समाज का सर्वे व 2500 परिवारों का विवरण दो निरदेशिकाओं में प्रकाशित। मंत्री श्री सुखदेवप्रसादजी कीरी के समर्पित प्रयासों का परिणाम था यह।',
        'खुला अधिवेशन। 400 समाज बंधुओं की उपस्थिति व 45 विद्वजनों द्वारा अभिव्यक्तियां।'
      ]
    },
    {
      id: 2,
      title: 'द्वितीय कार्यकारिणी / Second Executive Committee',
      tenure: '17 जून, 1990 से 10 जून, 1993',
      electionDate: '18 जून, 1990 को प्रतिनिधि सम्मेलन में चयनित',
      members: [
        { position: 'अध्यक्ष', name: 'श्री नारायणदास लक्ष्मणदास जी वारडे', location: 'अमरावती', type: 'elected' },
        { position: 'मंत्री', name: 'श्री आशाराम हीरालालजी छूंछा', location: 'बीकानेर', type: 'elected' },
        { position: 'उपाध्यक्ष', name: 'श्री लक्ष्मणदास खूबचंदजी बिछड़ा', location: 'मोहनगढ', type: 'nominated' },
        { position: 'उपमंत्री', name: 'श्री बाबुलाल हीरालालजी छूंछा', location: 'जोधपुर', type: 'nominated' },
        { position: 'कोषाध्यक्ष', name: 'श्री चितरंजन जेठमलजी भूत', location: 'बीकानेर', type: 'nominated' },
      ],
      activities: [
        'सिलाई प्रशिक्षण केंद व सिलाई मशीन वितरण।',
        'छात्रवृत्ति वितरण।',
        'सामाजिक व पारिवारिक मामलों का हल।'
      ]
    },
    {
      id: 3,
      title: 'तृतीय कार्यकारिणी / Third Executive Committee',
      tenure: '11 जून, 1993 से...',
      electionDate: '11 जून, 1993 को चयनित',
      members: [
        { position: 'अध्यक्ष', name: 'श्री बाबूलाल हीरालालजी छूंछा', location: 'जोधपुर', type: 'elected' },
        { position: 'मंत्री', name: 'श्री माणकलाल अर्जुनमलजी भूत', location: 'जोधपुर', type: 'elected' },
        { position: 'कोषाध्यक्ष', name: 'श्री तगाराम सोहनराजजी कीरी', location: 'जोधपुर', type: 'elected' },
      ],
      activities: [
        'सभाओं का आयोजन।',
        'मृत्युभोज बंद करवाने के प्रयास।',
        'शिक्षा व चिकित्सा के लिये सुविधायें।'
      ],
      note: 'अध्यक्ष श्री बाबूलालजी छूंछा व कोषाध्यक्ष श्री तगाराम कीरी का स्वर्गवास हो गया। मंत्री श्री माणकलालजी भूत अकेले पड़ गये व लम्बे समय तक महासभा निष्क्रिय रही।'
    },
    {
      id: 4,
      title: 'पुनर्गठित कार्यकारिणी (2022) / Reconstituted Committee',
      tenure: '10 अप्रैल, 2022 से...',
      electionDate: '10.04.2022 को जोधपुर में अधिवेशन में चयनित (एक वर्ष के लिये)',
      members: [
        { position: 'अध्यक्ष', name: 'श्री बंशीधर चैनारामजी छूंछा', location: 'चैन्नई', type: 'elected' },
        { position: 'मंत्री', name: 'श्री कन्हैयालाल बूलचंदजी वारडे', location: 'जोधपुर', type: 'elected' },
        { position: 'उपाध्यक्ष', name: 'श्री कन्हैयालाल अगरचंदजी भूत', location: 'बाड़मेर', type: 'nominated' },
        { position: 'उपमंत्री', name: 'श्री राधाकिशन पूनमचंदजी गिराछ', location: 'पोकरण', type: 'nominated' },
        { position: 'कोषाध्यक्ष', name: 'श्री जेठानंद मेघराजजी कीरी', location: 'जोधपुर', type: 'nominated' },
      ],
      activities: [
        'अध्यक्ष श्री बंशीधरजी छूंछा ने भारत भर में भ्रमण कर एकता व संगठन का संदेश दिया।',
        'महासभा का पंजीकरण कराने का प्रयास किया गया।',
        '30.12.2023 को ब्रह्मक्षत्रिय मारवाड़ी खत्री एसोसिएशन के नाम से पंजीकरण हुआ व पंजीकृत कार्यालय दिल्ली में स्थित हुआ।'
      ]
    },
    {
      id: 5,
      title: 'वर्तमान कार्यकारिणी (2024) / Current Executive Committee',
      tenure: '29 सितंबर, 2024 से वर्तमान',
      electionDate: '29 सितंबर, 2024 को जोधपुर में साधारण सभा में चयनित',
      members: [
        { position: 'अध्यक्ष', name: 'श्री जेठानंद मेघराजजी कीरी', location: 'जोधपुर', type: 'elected' },
        { position: 'मंत्री', name: 'पुष्पकुमार झूमरलालजी भूत', location: 'जोधपुर', type: 'elected' },
        { position: 'उपाध्यक्ष', name: 'श्री तोलाराम गणेमलजी छूंछा', location: 'जोधपुर', type: 'nominated' },
        { position: 'उपमंत्री', name: 'श्री जगदीश चुन्नीलालजी कीरी', location: 'बैंगलोर', type: 'nominated' },
        { position: 'उपमंत्री', name: 'श्री गौतम रतनलालजी कीरी', location: 'बालोतरा', type: 'nominated' },
      ],
      activities: [
        '22.12.2024 को कार्यकारिणी की प्रथम बैठक संपन्न हुयी।',
        'विधान संशोधन समिति, परिचय सम्मेलन व सामूहिक विवाह समिति, समन्वय समिति व छात्रवृत्ति समिति का गठन।',
        'परिचय संगम 2025 का सफल आयोजन।',
        'छात्रवृत्ति नीति पुनः लिखित।',
        'विधान संशोधन।',
        '14.09.2025 को साधारण सभा का अधिवेशन - विधान संशोधन।'
      ],
      isCurrent: true
    },
  ];

  const objectives1987 = [
    'समस्त मारवाड़ी ब्रह्मक्षत्रिय समाज में एकता स्थापित करना।',
    'राष्ट्र के अभिन्न अंग के रुप में समाज का विकास करना।',
    'सामाजिक झगड़ों का निष्पक्षता से निपटारा करना।',
    'समाजिक, सांस्कृतिक, आर्थिक व शैक्षणिक क्षेत्र में सर्वांगीण उन्नति करना।',
    'समाज में जागृति निर्माण कर कुरीतियों को दूर करना।',
    'समाज के आबालवृद्ध, अनाथ, उपेक्षित, असहाय व कमजोर अंगों की सहायता करना व उन्हें सम्मानित स्थान दिलवाना।'
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section - ICICI Style */}
      <section className="gradient-orange py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Breadcrumb */}
          <div className="flex items-center gap-2 text-white/80 text-sm mb-6">
            <a href="/" className="hover:text-white">Home</a>
            <span>›</span>
            <span>About</span>
          </div>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-3xl"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              About Khatri Mahasabha
            </h1>
            <p className="text-xl text-white/90 leading-relaxed">
              Building bridges, fostering unity, and preserving our heritage for future generations
            </p>
          </motion.div>
        </div>
      </section>

      {/* Sub Navigation - ICICI Style */}
      <div className="bg-white border-b border-gray-100 sticky top-20 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-8 overflow-x-auto py-4">
            {['History', 'Mission', 'Committees', 'Vision'].map((item, index) => (
              <button
                key={item}
                onClick={() => {
                  const element = document.getElementById(item.toLowerCase());
                  element?.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`text-sm font-medium whitespace-nowrap py-2.5 min-h-[40px] border-b-2 transition-colors ${
                  index === 0 
                    ? 'text-primary border-primary' 
                    : 'text-gray-600 border-transparent hover:text-primary'
                }`}
              >
                {item}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* History Section */}
        <motion.section
          id="history"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-8 section-heading">
            महासभा से एसोसिएशन तक
          </h2>
          <p className="text-gray-500 mb-8">From Mahasabha to Association - Our Journey</p>

          <div className="bg-white rounded-2xl border border-gray-100 shadow-card overflow-hidden">
            <div className="p-8">
              {/* Origin Story */}
              <div className="prose prose-lg max-w-none mb-8">
                <p className="text-gray-600 leading-relaxed mb-6">
                  समाज में केंद्रीय संगठन की कल्पना काफी पुरानी रही है और भूतकाल में समय समय पर इस ओर प्रयास किये जाते रहे हैं। औपचारिक केंद्रीय संगठन के न बनने से पूर्व भी समाज के सम्मेलन आयोजित होते रहे हैं व सामाजिक विषयों पर निर्णय लिये जाते रहे हैं।
                </p>
                <p className="text-gray-600 leading-relaxed">
                  1979 में स्थापित युवक मंडलों के केंद्रीय संगठन <strong className="text-gray-900">श्री ब्रह्मक्षत्रिय मारवाड़ी युवक परिषद्</strong> के अनुभवों व उसके द्वारा मासिक <strong className="text-gray-900">हिंगलाजज्योति</strong> के प्रकाशन के बाद आयी जागरूकता से समाज के अखिल भारतीय स्तर पर संगठन स्थापित की आवश्यकता और बलवती हुयी।
                </p>
              </div>

              {/* Formation - 1987 - ICICI Style Card */}
              <div className="bg-gradient-to-br from-primary/5 to-transparent rounded-xl p-6 border-l-4 border-primary mb-8">
                <div className="flex items-center gap-2 mb-4">
                  <Calendar className="w-5 h-5 text-primary" />
                  <h3 className="font-bold text-xl text-gray-900">
                    30-31 मई, 1987 - महासभा की स्थापना
                  </h3>
                </div>
                <p className="text-gray-600 leading-relaxed mb-4">
                  समाज के अग्रणी महानुभावों ने युवाओं को साथ लेते हुये समाज के केंद्रीय संगठन के लिये प्रयास तेज किये। अंततः <strong className="text-gray-900">30 व 31 मई, 1987</strong> को जोधपुर में सम्पन्न "समस्त मारवाड़ी ब्रह्मक्षत्रिय समाज के सम्मेलन में <strong className="text-primary">अखिल भारतीय मारवाड़ी ब्रह्मक्षत्रिय महासभा</strong> की स्थापना हुयी।
                </p>
                <p className="text-gray-600 leading-relaxed">
                  सम्मेलन में समाज की <strong className="text-gray-900">51 पंचायतों व संस्थाओं</strong> के चुने हुये <strong className="text-gray-900">83 प्रतिनिधियों</strong> ने सर्वसम्मति से विधान पारित कर महासभा का गठन किया।
                </p>
              </div>

              {/* Objectives 1987 */}
              <div className="mb-8">
                <h3 className="font-bold text-xl text-gray-900 mb-4 flex items-center gap-2">
                  <Target className="w-5 h-5 text-primary" />
                  1987 के विधान के अनुसार उद्देश्य
                </h3>
                <div className="grid gap-3">
                  {objectives1987.map((objective, index) => (
                    <div key={index} className="flex items-start gap-3 bg-gray-50 p-4 rounded-lg">
                      <CheckCircle2 className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                      <span className="text-gray-700">{objective}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Download 1987 Constitution */}
              <div className="bg-gray-50 p-4 rounded-lg flex items-center justify-between flex-wrap gap-4">
                <div className="flex items-center gap-3">
                  <FileText className="w-5 h-5 text-primary" />
                  <span className="text-gray-700 font-medium">1987 में पारित विधान</span>
                </div>
                <Button variant="outline" size="sm" className="border-gray-200 hover:border-primary hover:text-primary">
                  <Download className="w-4 h-4 mr-2" /> डाउनलोड करें
                </Button>
              </div>
            </div>
          </div>
        </motion.section>

        {/* Executive Committees Section */}
        <motion.section
          id="committees"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-8 section-heading">
            कार्यकारिणी समितियां
          </h2>
          <p className="text-gray-500 mb-8">Executive Committees Timeline</p>

          <div className="space-y-4">
            {executiveCommittees.map((committee) => (
              <div 
                key={committee.id} 
                className={`bg-white rounded-xl border overflow-hidden transition-all ${
                  committee.isCurrent ? 'border-primary shadow-glow' : 'border-gray-100 shadow-card'
                }`}
              >
                <div 
                  className={`p-6 cursor-pointer ${committee.isCurrent ? 'bg-primary/5' : 'hover:bg-gray-50'}`}
                  onClick={() => setExpandedSection(expandedSection === `committee-${committee.id}` ? '' : `committee-${committee.id}`)}
                >
                  <div className="flex items-center justify-between">
                    <div>
                      {committee.isCurrent && (
                        <span className="inline-block bg-primary text-white text-xs font-bold px-3 py-1 rounded-full mb-2">
                          वर्तमान / Current
                        </span>
                      )}
                      <h4 className="font-bold text-lg text-gray-900">
                        {committee.title}
                      </h4>
                      <p className="text-sm text-gray-500 flex items-center gap-2 mt-1">
                        <Calendar className="w-4 h-4" />
                        कार्यकाल: {committee.tenure}
                      </p>
                    </div>
                    <div className="flex items-center gap-4">
                      <span className="text-sm text-gray-400">{committee.members.length} members</span>
                      {expandedSection === `committee-${committee.id}` ? (
                        <ChevronUp className="w-5 h-5 text-gray-400" />
                      ) : (
                        <ChevronDown className="w-5 h-5 text-gray-400" />
                      )}
                    </div>
                  </div>
                </div>

                {expandedSection === `committee-${committee.id}` && (
                  <div className="p-6 border-t border-gray-100 bg-gray-50/50">
                    {committee.electionDate && (
                      <p className="text-sm text-primary font-medium mb-4">
                        {committee.electionDate}
                      </p>
                    )}

                    {/* Members Table */}
                    <div className="overflow-x-auto mb-6">
                      <table className="w-full text-sm">
                        <thead>
                          <tr className="border-b border-gray-200">
                            <th className="text-left py-3 px-4 font-semibold text-gray-500">पद</th>
                            <th className="text-left py-3 px-4 font-semibold text-gray-500">नाम</th>
                            <th className="text-left py-3 px-4 font-semibold text-gray-500">स्थान</th>
                            <th className="text-left py-3 px-4 font-semibold text-gray-500">प्रकार</th>
                          </tr>
                        </thead>
                        <tbody>
                          {committee.members.map((member, idx) => (
                            <tr key={idx} className="border-b border-gray-100 last:border-0">
                              <td className="py-3 px-4 font-medium text-gray-900">{member.position}</td>
                              <td className="py-3 px-4 text-gray-700">{member.name}</td>
                              <td className="py-3 px-4 text-gray-500">{member.location}</td>
                              <td className="py-3 px-4">
                                <span className={`text-xs px-3 py-1 rounded-full font-medium ${
                                  member.type === 'elected' 
                                    ? 'bg-green-100 text-green-700' 
                                    : 'bg-blue-100 text-blue-700'
                                }`}>
                                  {member.type === 'elected' ? 'निर्वाचित' : 'मनोनीत'}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Activities */}
                    {committee.activities && committee.activities.length > 0 && (
                      <div className="mb-4">
                        <h5 className="font-semibold text-gray-900 mb-3">गतिविधियां:</h5>
                        <ul className="space-y-2">
                          {committee.activities.map((activity, idx) => (
                            <li key={idx} className="flex items-start gap-3 text-sm text-gray-600">
                              <span className="w-1.5 h-1.5 bg-primary rounded-full mt-2 flex-shrink-0" />
                              {activity}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}

                    {/* Note */}
                    {committee.note && (
                      <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg text-sm text-yellow-800">
                        <strong>नोट:</strong> {committee.note}
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </motion.section>

        {/* Mission Section */}
        <motion.section
          id="mission"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <h2 className="text-3xl font-bold text-gray-900 mb-8 section-heading">
            Our Mission
          </h2>
          <p className="text-gray-500 mb-8">हमारा उद्देश्य</p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              {
                icon: <Users className="w-6 h-6" />,
                title: 'Unity / एकता',
                description: 'समस्त मारवाड़ी ब्रह्मक्षत्रिय समाज में एकता स्थापित करना और विविध सदस्यों को एक साथ लाना।',
              },
              {
                icon: <BookOpen className="w-6 h-6" />,
                title: 'Social & Educational Upliftment',
                description: 'समाजिक, सांस्कृतिक, आर्थिक व शैक्षणिक क्षेत्र में सर्वांगीण उन्नति करना।',
              },
              {
                icon: <Heart className="w-6 h-6" />,
                title: 'Community Welfare',
                description: 'समाज के आबालवृद्ध, अनाथ, उपेक्षित, असहाय व कमजोर अंगों की सहायता करना।',
              },
              {
                icon: <Award className="w-6 h-6" />,
                title: 'Heritage & Culture',
                description: 'सामाजिक व सांस्कृतिक परम्पराओं को अक्षुण्ण रखते हुये बदलते समय के अनुसार परिष्कृत करना।',
              },
            ].map((item, index) => (
              <motion.div 
                key={item.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-xl border border-gray-100 p-6 shadow-card hover:shadow-card-hover transition-all card-hover"
              >
                <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center text-primary mb-4">
                  {item.icon}
                </div>
                <h3 className="font-bold text-lg text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600 leading-relaxed">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.section>

        {/* Vision Section */}
        <motion.section
          id="vision"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div className="gradient-dark rounded-2xl p-12 text-center text-white">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Our Vision</h2>
            <p className="text-xl max-w-3xl mx-auto text-white/80 leading-relaxed">
              Our digital platform is designed to serve our community, evolving
              with technology while staying true to our core values. Together, we build a legacy that
              will benefit generations to come.
            </p>
          </div>
        </motion.section>
      </div>
    </div>
  );
};

export default AboutPage;
